import React from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import useSiteCopySelector from 'components/useSiteCopySelector';
import Mixpanel from 'utils/mixpanelService';
import { getTrackingPageName } from 'utils/stringUtils';

const useStyles = makeStyles(theme => ({
  container: {
    zIndex: 9998,
    boxShadow: '0px 0px 14px 0px #00000033',
    maxWidth: 450,
    borderRadius: 20,
    backgroundColor: 'white',
    position: 'fixed',
    width: 'auto',
    top: 40,
    right: 40,
    [theme.breakpoints.down('xs')]: {
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      right: 'auto',
      width: '90%',
    },
  },
  header: {
    fontWeight: 600,
    fontSize: 22,
    color: theme.palette.text.primary,
    fontFamily: 'Poppins',
  },
  content: {
    padding: '39px 50px',
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      padding: '19px 25px',
    },
  },
  description: {
    marginTop: 20,
    fontSize: 20,
    color: theme.palette.text.primary,
  },
  cta: {
    width: '100%',
    fontWeight: 'bold',
    marginTop: 20,
    padding: 14,
    borderRadius: 8,
  },
  dismiss: {
    marginTop: 15,
    fontSize: 14,
    cursor: 'pointer',
    color: theme.palette.text.secondary,
    textDecoration: 'underline',
  },
}));

export default function EmailLoginReminderDialog({ open, onClose, onLogin }) {
  const classes = useStyles();
  const [signInSiteCopy] = useSiteCopySelector(['sign-in']);
  const {
    welcomeBackHeader,
    signInPrompt,
    benefitsDescription,
    loginButtonLabel,
    dismissButtonLabel,
  } = signInSiteCopy?.pageCopy?.emailLoginReminder || {};
  if (!open) return null;

  const handleLogin = () => {
    Mixpanel.track('Login Reminder - Clicked', {
      page: getTrackingPageName(),
    });
    onLogin();
  };

  const handleClose = () => {
    Mixpanel.track('Login Reminder - Dismissed', {
      page: getTrackingPageName(),
    });
    onClose();
  };

  return (
    <Grid container justifyContent="center" className={classes.container}>
      <Grid item xs={12} className={classes.content}>
        <Typography className={classes.header}>{welcomeBackHeader}</Typography>
        <Typography className={classes.header}>{signInPrompt}</Typography>
        <Typography className={classes.description}>
          {benefitsDescription}
        </Typography>
        <Button
          color="primary"
          variant="contained"
          className={classes.cta}
          onClick={handleLogin}
        >
          {loginButtonLabel}
        </Button>
        <Typography className={classes.dismiss} onClick={handleClose}>
          {dismissButtonLabel}
        </Typography>
      </Grid>
    </Grid>
  );
}
